export const REQUEST_COUPON_DATA = 'REQUEST_COUPON_DATA'
export const SET_COUPON_STATE = 'SET_COUPON_STATE'
export const SET_COUPON_DATA = 'SET_COUPON_DATA'
